import { Link } from 'react-router-dom';
import { ArrowUpRight, Share2 } from 'lucide-react';

import blogs from '../mock/Blogs';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import Container from './Main/sections/Container';

const Blogs = () => {
  return (
    <>
      <PageHero
        eyebrow="Blog"
        title="Study Smarter,"
        titleAccent="One Read at a Time"
        subtitle="Tips, guides, and product updates to help you get the most out of School Hack."
      />

      <section className="relative pb-24">
        <Container>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {blogs.map((el, id) => (
              <Reveal key={id} delay={(id % 3) * 90}>
                <Link
                  to={`/blogs/${el.link}/`}
                  className="glass glass-hover group flex h-full flex-col overflow-hidden rounded-2xl"
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={el.img}
                      alt={el.title}
                      className="h-[200px] w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0b100e] to-transparent opacity-60" />
                  </div>

                  <div className="flex flex-1 flex-col p-5">
                    <div className="mb-3 flex items-center gap-2 text-[0.75rem] text-white/45">
                      <img
                        src={el.avatar}
                        alt=""
                        className="h-6 w-6 rounded-full object-cover ring-1 ring-white/10"
                      />
                      <span className="font-medium text-white/70">{el.name}</span>
                      <span>·</span>
                      <span>{el.date}</span>
                    </div>

                    <h3 className="font-heading text-[1.1rem] font-semibold leading-snug text-white group-hover:text-accent">
                      {el.title}
                    </h3>
                    <p className="mt-2 line-clamp-3 text-[0.88rem] leading-relaxed text-white/55">
                      {el.description}
                    </p>

                    <div className="mt-auto flex items-center justify-between pt-5">
                      <span className="inline-flex items-center gap-1.5 text-[0.85rem] font-semibold text-accent">
                        Read post
                        <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                      </span>
                      <span className="flex items-center gap-1.5 text-[0.78rem] text-white/40">
                        <Share2 size={13} />
                        {el.shares} shares
                      </span>
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

export default Blogs;
